export enum IMPACT_ACTIONS {
	CREATE = "CREATE",
	UPDATE = "UPDATE",
}
